export default __webpack_public_path__ + "static/media/Remilekun.1aaf7b9e.jpg";